import React, { Component } from "react";
import {Link} from 'react-router-dom'

export default class LiveClass extends Component {
  state = {
    courses: [
      {
        name: "Math",
        teacher: "James stunner",
        time: "10 AM",
        duration :"30 min",
        image:
          "https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
      },
      {
        name: "Chemistry",
        teacher: "Gary smith",
        time: "10 AM",
        duration :"30 min",
        image:
          "http://steezo.com/wp-content/uploads/2012/12/man-in-suit2.jpg"
      },
      {
        name: "Biology",
        teacher: "Luis james",
        time: "10 AM",
        duration :"30 min",
        image:
          "https://media.istockphoto.com/photos/happy-laughing-man-picture-id544358212?k=6&m=544358212&s=612x612&w=0&h=odURMNz2hty8LIfpVahaaUKpGU4vd-UlZx4jy-OAnJA="
      },
      {
        name: "Technology",
        teacher: "Chris steve",
        time: "10 AM",
        duration :"30 min",
        image:
          "https://image.shutterstock.com/image-photo/close-portrait-smiling-handsome-man-260nw-1011569245.jpg"
      }
    ]
  };
  render() {
    return (
      <div>
        <div className="container">
          <div className="mt-4 mb-3">
            <h4>Live Classes</h4>
          </div>
          <div class="row" id="filter">
            <div class="form-group col-sm-3 col-xs-6">
              <select
                data-filter="make"
                class="filter-make filter form-control"
              >
                <option value="">Courses</option>
                <option value="">Show All</option>
              </select>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <select
                data-filter="model"
                class="filter-model filter form-control"
              >
                <option value="">Subjects</option>
                <option value="">Show All</option>
              </select>
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              {/* <select data-filter="type" class="filter-type filter form-control">
              <option value="">Topics</option>
              <option value="">Show All</option>
            </select> */}
            </div>
            <div class="form-group col-sm-3 col-xs-6">
              <div class="input-group search-box">
                <input
                  type="text"
                  id="search"
                  class="form-control"
                  placeholder="Search here"
                />
                <span class="input-group-addon">
                  <i class="material-icons">&#xE8B6;</i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr className="m-0 mt-2 mb-3" />
        <div className="container">
          <div className="row">
            {this.state.courses.map(course => {
              return (
                <div className="col-md-3 my-3">
                  <div className="card card-selector shadow-sm" onClick={this.cardSelect}>
                    <div className="d-flex align-items-center justify-content-center">
                    <img
                      class="image-cover"
                      src={course.image}
                      alt="Card image"
                    />
                    </div>
                    <div class="card-body pt-0 text-center">
                      <h5 className="mb-0">{course.name}</h5>
                      <p className="blockquote-footer m-0">
                        By {course.teacher}
                      </p>

                      <p class="card-text pt-2 m-0">Today</p>
                      <p class="card-text">{course.time} - {course.duration}</p>
                      <Link to="/join" class="btn btn-primary">
                        Join
                      </Link>
                    </div>
                    <div className="class-price">&#8377;100</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
